<template>
  <!-- DOTS MENU -->
  <div
    :dir="isDesktop ? 'rtl' : 'ltr'"
    :style="isDesktop ? '' : 'top:56px;'"
    class="open-nav-dots shown"
  >
    <!-- RESCHED SURG BTN -->
    <div
      v-show="!isSelectedDatePassed"
      class="row flex flex--end block_action resched-btn"
    >
      <span class="resched-btn">שיבוץ מחדש</span>
      <RescheduleIcon class="menu-icon" />
    </div>
    <!-- EDIT SURG BTN -->
    <div
      v-show="!isSelectedDatePassed"
      class="row flex flex--end block_action edit-btn"
    >
      <span class="edit-btn">עריכת ניתוח</span>
      <EditIcon class="menu-icon" />
    </div>
    <!-- ADD SURG DOCS -->
    <div class="row flex flex--end block_action doc-btn">
      <span class="doc-btn">הוספת מסמכים</span>
      <FileAddIcon class="menu-icon" />
    </div>
    <!-- PATIENT REQUESTS -->
    <div class="row flex flex--end block_action patient-requests-btn">
      <span class="patient-requests-btn">בקשות מטופל</span>
      <ClipboardListIcon class="menu-icon" />
    </div>
    <!-- CELLOSIGN BTN -->
    <div v-if="showIVF" class="row flex flex--end block_action cellosign-btn">
      <span class="cellosign-btn">טפסי הסכמה</span>
      <FileCheckIcon class="menu-icon" />
    </div>
    <!-- SEND SURG SPECIAL APPROVAL -->
    <div
      v-if="showExceptionCommittee"
      class="row flex flex--end block_action special-approval-btn"
    >
      <span class="special-approval-btn">הגשה לוועדת חריגים</span>
      <SendIcon class="menu-icon" />
    </div>
    <!-- SEND SMS BTN -->
    <div id="sms-line" class="row flex flex--end block_action sms-btn">
      <span id="sms-label" class="sms-btn">שליחת הודעה</span>
      <MessageIcon class="menu-icon" />
    </div>

    <div class="row flex flex--end block_action whatsapp-btn">
      <span class="whatsapp-btn">שליחת וואטסאפ</span>
      <WhatsappIcon class="menu-icon" />
    </div>
  </div>
  <!-- END DOTS MENU -->
</template>

<script>
import { mapGetters } from "vuex";
import RescheduleIcon from "@/assets/img/svg/actions/reschedule.svg";
import EditIcon from "@/assets/img/svg/actions/edit.svg";
import FileAddIcon from "@/assets/img/svg/actions/file-add.svg";
import ClipboardListIcon from "@/assets/img/svg/actions/clipboard-list.svg";
import FileCheckIcon from "@/assets/img/svg/actions/file-check.svg";
import SendIcon from "@/assets/img/svg/actions/send.svg";
import MessageIcon from "@/assets/img/svg/actions/message.svg";
import WhatsappIcon from "@/assets/img/svg/actions/whatsapp.svg";
import { EXCEPTION_COMMITTEE_ENABLED } from "../../../utilities/feature-flags.js";

export default {
  name: "SurgMobileDotsMenu",
  props: ["event", "isSelectedDatePassed", "isDesktop"],
  components: {
    RescheduleIcon,
    EditIcon,
    FileAddIcon,
    ClipboardListIcon,
    FileCheckIcon,
    SendIcon,
    MessageIcon,
    WhatsappIcon
  },
  computed: {
    ...mapGetters(["showIVF"]),
    showExceptionCommittee() {
      return EXCEPTION_COMMITTEE_ENABLED;
    }
  }
};
</script>
<style scoped>
/* Uniform icon system: one style, one size for every action. */
.menu-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  color: #324997;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
/* Override the global 14px gap so icon and label sit closer together. */
.open-nav-dots .row .menu-icon {
  margin-right: 7px;
  margin-left: 7px;
}
/* Tighten the row's horizontal padding (global is 11px 12px). */
.open-nav-dots .row {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
